import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionModules } from '../../data/license.data';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';
import { ISubscriptionModule } from 'src/app/common/model/license.model';
import { SIBASI_SYSTEM_APP_MODULES } from 'src/app/common/model/sibasi-system.model';

@Component({
  selector: 'app-license-not-subscribed-view',
  standalone: true,
  templateUrl: './license-not-subscribed-view.component.html',
  styleUrls: ['./license-not-subscribed-view.component.scss'],
  imports: [CommonModule, ButtonModule, RouterModule]
})
export class LicenseNotSubscribedViewComponent implements OnInit {
  @Input() module!: SIBASI_SYSTEM_APP_MODULES;
  moduleDetails!: ISubscriptionModule;

  ngOnInit(): void {
    this.getModuleDetails();
  }

  getModuleDetails(): void {
    const subscriptionModules = SubscriptionModules;
    const moduleDetails = subscriptionModules.find((x) => x.module === this.module);
    this.moduleDetails = moduleDetails ? moduleDetails : SubscriptionModules[0];
  }
}
